import { useEffect, useState } from "react";
import { useQuestionizerStore } from "../types/state.ts";
import PreviewView from "./questionizer-result-overlay-preview-view.tsx";
import { QuestionizerAccordion } from "./questionizer-result-accordion.tsx";

export function QuestionizerResultOverlay() {
  const darlehenList = useQuestionizerStore((state) => state.darlehenList);
  const zuschuesseList = useQuestionizerStore((state) => state.zuschuesseList);
  const setZuschuesseList = useQuestionizerStore((state) => state.setZuschuesseList);
  const activeListLabel = useQuestionizerStore((state) => state.activeListLabel);
  const activeListType = useQuestionizerStore((state) => state.activeListType);
  const activeFpId = useQuestionizerStore((state) => state.activeFpId);
  const activeListTypeLabel = activeListType === "zuschuss" ? "Zuschüsse" : "Darlehen";

  if (!darlehenList || !zuschuesseList) return <></>;

  return (
    <div className="relative bg-white inset-0">
      {!activeFpId ? (
        <>
          <h2 className="text-xl font-bold mb-2">
            {activeListTypeLabel} &ndash; {activeListLabel}
          </h2>
          <p className="mb-4">
            Bitte klicken Sie den Namen einer Förderung an, um die Details zu sehen
          </p>
          {zuschuesseList && activeListType === "zuschuss" && (
            <QuestionizerAccordion active regions={zuschuesseList} />
          )}
          {darlehenList && activeListType === "darlehen" && (
            <QuestionizerAccordion active regions={darlehenList} />
          )}
        </>
      ) : (
        <PreviewView />
      )}
    </div>
  );
}